import React from 'react';
import './RetailerListSkeleton.scss';

const RetailerListSkeleton = () => {
    return (
        <div className="retailer-list-skeleton">
            {/* Filters Section */}
            <div className="skeleton-filters-section">
                {/* Button Group for Retailer Type Filter */}
                <div className="skeleton-button-group">
                    <div className="skeleton-filter-button"></div>
                    <div className="skeleton-filter-button"></div>
                </div>
                <div className="skeleton-filters-row">
                    <div className="skeleton-select"></div>
                    <div className="skeleton-input"></div>
                    <div className="skeleton-date-group">
                        <div className="skeleton-date-field">
                            <div className="skeleton-date-label"></div>
                            <div className="skeleton-date-input"></div>
                        </div>
                        <div className="skeleton-date-field">
                            <div className="skeleton-date-label"></div>
                            <div className="skeleton-date-input"></div>
                        </div>
                    </div>
                    <div className="skeleton-button"></div>
                </div>
                <div className="skeleton-download-button"></div>
            </div>

            {/* Table Section */}
            <div className="skeleton-table-section">
                <div className="skeleton-table">
                    <div className="skeleton-table-header">
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                    </div>
                    <div className="skeleton-table-body">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
                            <div key={row} className="skeleton-table-row">
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td skeleton-td-action"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Pagination Section */}
            <div className="skeleton-pagination-section">
                <div className="skeleton-pagination">
                    <div className="skeleton-page-button"></div>
                    <div className="skeleton-page-button"></div>
                    <div className="skeleton-page-button"></div>
                    <div className="skeleton-page-button"></div>
                    <div className="skeleton-page-button"></div>
                </div>
                <div className="skeleton-results-text"></div>
            </div>
        </div>
    );
};

export default RetailerListSkeleton;
